import React, { Component, useState, useEffect } from 'react';
import { useGetAllCompanyCode, useGetDesignations, useRegisterUser } from '../../hooks/useSignup';
import { Form, Select, Button, Space, Tag, notification } from 'antd';
import { CloseCircleOutlined, LogoutOutlined } from '@ant-design/icons';
import stc from 'string-to-color';
import useLogout from '../../hooks/useLogout';

export default function SignUp({ user }) {
    const [api, contextHolder] = notification.useNotification();
    const { logout } = useLogout();

    const { data: companyCodeList, isError } = useGetAllCompanyCode();
    const { data: designationList } = useGetDesignations();

    const RegisterUserMutation = useRegisterUser();

    const [form] = Form.useForm();

     if (isError) {
        logout();
    }
    
    useEffect(() => {
        console.log('useEffect', designationList?.data);
    }, [designationList]);

    const HandleFormFinish = data => {
        console.log(data);
        RegisterUserMutation.mutateAsync([data?.companies, data?.designation])
            .then(() => {
                api.success({ message: 'Successfully Sent For Approval' });
            })
            .catch(error => {
                api.error({ message: 'Some error', description: error?.message });
            })
            .finally(() => {
                logout();
            });
    };

    return (
        <>
            {contextHolder}
            <div
                style={{
                    border: '1px solid red',
                    display: 'flex',
                    width: '100%',
                    height: '100vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        width: '500px',
                        border: '1px solid gray',
                        padding: '0 0 0 0',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '13px',
                        display: 'flex',
                        position: 'relative',
                        flexDirection: 'column',
                    }}
                >
                    {user?.signupStatus == 2 && (
                        <div
                            style={{
                                width: '100%',
                                height: '50px',
                                backgroundColor: 'red',
                                color: 'white',
                                borderRadius: '13px',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                padding: '0 13px',
                            }}
                        >
                            <Space>
                                <CloseCircleOutlined style={{ fontSize: '2rem' }} />
                                <p style={{ fontSize: '1.25rem' }}>Your Previous request was rejected!!</p>
                            </Space>
                        </div>
                    )}
                    <br />
                    <img
                        src="https://flixstudio.flixstock.com/images/logo.png"
                        style={{
                            width: '100px',
                            height: '100px',
                        }}
                        alt="icon"
                    ></img>
                    <h2>
                        Welcome, <h2>{user?.name}</h2>
                    </h2>
                    <br />
                    <i style={{ padding: '0 10px' }}>
                        <p>Please sign up to Flixstudio Dashboard to access all of your clients.</p>
                        <p>This Helps us in Focusing your attention to only the client you need to see.</p>
                    </i>
                    <br />
                    <hr />
                    <h1
                        style={{
                            margin: '15px 0 30px 0',
                            backgroundColor: 'gray',
                            width: '100%',
                            textAlign: 'center',
                            color: 'white',
                            // padding: '0 10px',
                        }}
                    >
                        SignUp Form
                    </h1>
                    <Form
                        onFinish={HandleFormFinish}
                        style={{
                            width: '100%',
                            padding: '0 10px',
                        }}
                    >
                        <Form.Item
                            label="Select Companies"
                            name="companies"
                            rules={[
                                {
                                    type: 'array',
                                    min: 1,
                                    message: 'Please select atlease one client code.',
                                    required: true,
                                },
                            ]}
                        >
                            <Select
                                mode="multiple"
                                options={companyCodeList?.data?.map(company => {
                                    return {
                                        label: <Tag color={stc(company?.code)}>{company?.code}</Tag>,
                                        value: company?.code,
                                    };
                                })}
                                showSearch
                                allowClear
                                maxTagCount={1}
                                optionFilterProp="value"
                            />
                        </Form.Item>
                        <Form.Item
                            label="Select Your Designation"
                            name="designation"
                            rules={[
                                {
                                    type: 'string',
                                    message: 'Please select your designation',
                                    required: true,
                                },
                            ]}
                        >
                            <Select
                                mode="single"
                                options={designationList?.designations?.map(designation => {
                                    return { label: designation, value: designation };
                                })}
                                optionFilterProp="label"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button block type="primary" htmlType="submit" hidden={true}>
                                Send For Approval
                            </Button>
                        </Form.Item>
                    </Form>
                    <Button
                        // block
                        style={{
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                            backgroundColor: 'red',
                        }}
                        type="primary"
                        onClick={() => logout()}
                    >
                        <LogoutOutlined />
                    </Button>
                </div>
            </div>
        </>
    );
}
